import { LayoutDashboard, Settings, Users, type LucideIcon } from 'lucide-react'
import { de } from '../i18n'

export interface NavItem {
  to: string
  label: string
  icon: LucideIcon
  end: boolean
}

/** The three views task 6 lays the shell for; tasks 7 and 8 fill dashboard
    and users/settings respectively — this list does not grow with them. */
export const NAV_ITEMS: NavItem[] = [
  { to: '/', label: de.nav.dashboard, icon: LayoutDashboard, end: true },
  { to: '/nutzer', label: de.nav.users, icon: Users, end: false },
  { to: '/einstellungen', label: de.nav.settings, icon: Settings, end: false },
]
